export const SyncOperation = { Create: 0, Update: 1, Delete: 2 } as const
export type SyncOperationType = typeof SyncOperation[keyof typeof SyncOperation]

export const SyncStatus = { Applied: 0, Conflict: 1, ShiftLocked: 2, NotFound: 3, Error: 4 } as const
export type SyncStatusType = typeof SyncStatus[keyof typeof SyncStatus]

export interface StoppageMutation {
  clientId: string
  operation: SyncOperationType
  stoppageId?: number
  rowVersion?: string
  shiftId: number
  data?: unknown
}

export interface LoadingMutation {
  clientId: string
  operation: SyncOperationType
  loadingId?: number
  rowVersion?: string
  shiftId: number
  data?: unknown
}

export interface DiggingPatternMutation {
  clientId: string
  operation: SyncOperationType
  diggingPatternId?: number
  rowVersion?: string
  shiftId: number
  data?: unknown
}

export interface PatternBlastMutation {
  clientId: string
  operation: SyncOperationType
  data: unknown
}

export interface CompleteShiftMutation {
  clientId: string
  shiftId: number
}

export interface GeoRehandleMutation {
  clientId: string
  operation: SyncOperationType
  geoRehandleId?: number
  data?: unknown
}

export interface SyncRequest {
  patternBlasts: PatternBlastMutation[]
  diggingPatterns: DiggingPatternMutation[]
  loadings: LoadingMutation[]
  stoppages: StoppageMutation[]
  completeShifts: CompleteShiftMutation[]
  geoRehandles: GeoRehandleMutation[]
}

export interface SyncMutationResult {
  clientId: string
  status: SyncStatusType
  serverId?: number
  serverState?: unknown
}

export interface SyncResponse {
  results: SyncMutationResult[]
}
